import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';

var _excluded = ["defaultValue", "highlighted", "state"];
var Textarea = /*#__PURE__*/forwardRef(function Textarea(props, ref) {
  var _cn;

  var highlighted = props.highlighted,
      state = props.state,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var classNames = cn('yt-textarea', 'yt-input', (_cn = {}, _cn["yt-input--state-" + state] = !!state, _cn['yt-input--highlighted'] = highlighted, _cn), props.className);
  return createElement("textarea", Object.assign({}, otherProps, {
    className: classNames,
    ref: ref
  }));
});

export { Textarea };
//# sourceMappingURL=Textarea.js.map
